//@flow
import * as React from 'react';
import {
    Dialog,
    DialogHeader,
    DialogContent,
    DialogFooter,
    Heading,
    Button
} from '@locus-taxy/neo-ui';
import { useTranslation } from 'react-i18next';
import {
    RadioGroup,
    RadioButton
} from 'common/components/core/form/RadioButton';
import theme from './TerritoryConfig.scss';
type Props = {
    onNext: (selectedTerritoryType: string) => void,
    onDismiss: () => void
};

const TerritoryGenerationEnum = Object.freeze({
    AUTOMATIC: 'AUTOMATIC',
    MANUAL: 'MANUAL'
});

const TerritoryCreationTypeSelector = (props: Props): React.Node => {
    const [
        selectedTerritoryGenerationType,
        setSelectedTerritoryGenerationType
    ] = React.useState(TerritoryGenerationEnum.AUTOMATIC);

    const { t } = useTranslation('entityManagement');

    const selectTerritoryType = React.useCallback(
        type => {
            setSelectedTerritoryGenerationType(type);
        },
        [setSelectedTerritoryGenerationType]
    );

    const { onNext } = props;

    const onSelectTerritoryType = React.useCallback(() => {
        onNext(selectedTerritoryGenerationType);
    }, [onNext, selectedTerritoryGenerationType]);

    return (
        <Dialog isOpen sticky width="small">
            <DialogHeader>
                <Heading>{t('createTerritory.territoryTypeTitle')}</Heading>
            </DialogHeader>
            <DialogContent>
                <RadioGroup
                    onChange={selectTerritoryType}
                    value={selectedTerritoryGenerationType}
                    theme={theme}
                >
                    <RadioButton
                        theme={theme}
                        label={t('createTerritory.automaticLabel')}
                        value={TerritoryGenerationEnum.AUTOMATIC}
                        desc={t('createTerritory.automaticDescription')}
                    />
                    <RadioButton
                        theme={theme}
                        label={t('createTerritory.manualLabel')}
                        value={TerritoryGenerationEnum.MANUAL}
                        desc={t('createTerritory.manualDescription')}
                    />
                </RadioGroup>
            </DialogContent>
            <DialogFooter>
                <Button onClick={props.onDismiss}>
                    {t('translations:cancel')}
                </Button>
                <Button
                    appearance="solid"
                    palette="primary"
                    onClick={onSelectTerritoryType}
                >
                    {t('translations:proceed')}
                </Button>
            </DialogFooter>
        </Dialog>
    );
};

export default TerritoryCreationTypeSelector;
